import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database-deprecated';

import { AuthService } from '../../core/auth.service';
import { ServiceBase } from '../../shared/base/service-base';

import { Lesson } from './lesson';

@Injectable()
export class LessonService extends ServiceBase<Lesson> {
  constructor(db: AngularFireDatabase, private auth: AuthService) {
    super(db, '/lessons');
  }

  push(value: Lesson) {
    return super.push(Object.assign(new Lesson(), {
      owner: this.auth.auth.uid
    }, value));
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lessons/shared/lesson.service.ts